import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VybavaVozidla = {
	name: NAME,
	apiProvider,
	router,
};
